import axios from 'axios';
import { URI, URI_EVENT } from '../helpers/constans';
import {
  IAdminEventDetail,
  IAdminEventListItem,
  IEventGetResponseOk,
  IEventPutPayload,
  IEventPutResponseOk,
  TEventGetAllPayload,
} from '../types/@event';

export interface IAdminEventListResponse {
  data: IAdminEventListItem[];
  pages: number;
}

export const fetchEventGet = (page: TEventGetAllPayload): Promise<IEventGetResponseOk> => {
  return axios.get(`${URI_EVENT}?page=${page}`);
};

export const fetchEventPut = (payload: IEventPutPayload): Promise<IEventPutResponseOk> => {
  return axios.post(`${URI_EVENT}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const fetchEventStatusConfig = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/status-config`);
};

export const fetchEventStatusPhrase = (
  eventId: string,
  payload: { context: string; refinement: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/status-phrase`, payload);
};

export const fetchEventStatusApply = (
  eventId: string,
  payload: { ownerIds: string[]; text: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/status-apply`, payload);
};

export const fetchEventStatusPlayers = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/status-players`);
};

export const fetchEventPosts = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/posts`);
};

export const fetchEventSocialPublishState = (eventId: string, platform = 'instagram') => {
  return axios.get(`${URI_EVENT}/${eventId}/social-publish-state?platform=${encodeURIComponent(platform)}`);
};

export const fetchEventSocialPublish = (
  eventId: string,
  payload: { platform?: string; postKey?: string; qdosPostId?: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/social-publish`, payload, { timeout: 90000 });
};

export const fetchEventSocialSeed = (
  eventId: string,
  payload: { platform?: string; postKey?: string; qdosPostId?: string; shareUrl?: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/social-seed`, payload);
};

export const fetchEventSocialPostInsights = (
  eventId: string,
  payload: { platform?: string; providerPostId?: string; qdosPostId?: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/social-post-insights`, payload);
};

export const fetchEventPatch = (eventId: string, payload: Record<string, any>) => {
  return axios.patch(`${URI_EVENT}/${eventId}`, payload);
};

export const fetchEventRiveUpload = (
  eventId: string,
  orientation: 'portrait' | 'landscape',
  file: File,
): Promise<IAdminEventDetail> => {
  const payload = new FormData();
  payload.append(orientation, file);

  return axios.post(`${URI_EVENT}/${eventId}/rive`, payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }) as unknown as Promise<IAdminEventDetail>;
};

export const fetchEventActivateItems = (eventId: string) => {
  return axios.post(`${URI_EVENT}/${eventId}/activate-items`, {});
};

export const fetchEventLockTeamKit = (eventId: string) => {
  return axios.post(`${URI_EVENT}/${eventId}/lock-team-kit`, {});
};

export const fetchAdminEvents = async (
  page: number | undefined = 1,
): Promise<IAdminEventListResponse> => {
  return axios.get(`${URI}/admin/events?page=${page}`);
};

export const fetchAdminEventById = async (
  eventId: string,
): Promise<IAdminEventDetail> => {
  return axios.get(`${URI}/admin/events/${eventId}`);
};

export const fetchAdminEventRiveUpload = async (
  eventId: string,
  payload: FormData,
): Promise<IAdminEventDetail> => {
  return axios.post(`${URI}/admin/events/${eventId}/rive`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
